import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLeaveApplyEntry } from './hooks/useLeaveApplyEntry';
import LeaveApplyForm from './components/LeaveApplyForm';

export default function LeaveApplyEntryScreen() {
  const navigate = useNavigate();
  const { state, actions } = useLeaveApplyEntry();

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-12">
      {/* Header Banner with Back Button */}
      <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between border-b border-outline-variant/15 pb-4">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => navigate('/leave-apply')}
            className="flex h-10 w-10 items-center justify-center rounded-xl border border-outline-variant/30 bg-surface-container-lowest text-on-surface hover:bg-surface-container-high transition cursor-pointer shadow-xs"
            title="Back to Leave Applications"
          >
            <span className="material-symbols-outlined text-lg">arrow_back</span>
          </button>
          <div>
            <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-on-surface">
              {state.isView
                ? 'View Leave Application'
                : state.isEdit
                ? 'Edit Leave Application'
                : 'Leave Application'}
            </h1>
            <p className="mt-0.5 text-xs text-on-surface-variant font-medium">
              {state.isView
                ? 'Read-only view of employee leave request and balances'
                : 'Submit formal leave application for manager approval'}
            </p>
          </div>
        </div>
      </section>

      {/* Entry Form Component */}
      <LeaveApplyForm state={state} actions={actions} />
    </div>
  );
}
